import { HttpErrorResponse } from '@angular/common/http';
import { ApiException, ApiExceptionConstructor } from 'src/core/common/domain/exceptions/api-exception';

export class InternalServerException extends ApiException implements ApiExceptionConstructor {
  constructor(message?: string, error?: HttpErrorResponse | Error) {
    super(message, error);
    this.name = 'InternalServerException';
  }

  static fromError(error: HttpErrorResponse | Error): InternalServerException {
    return new this(error.message, error);
  }
}
